module.exports = __webpack_public_path__ + "img/refresh-left-square.89aabaf8.svg";